import { useRef, useLayoutEffect } from 'react';
export function useStickyHeader() {
    var header = useRef(undefined);
    useLayoutEffect(function () {
        if (header.current) {
            var sticky_1 = header.current.offsetTop;
            window.onscroll = function () {
                if (window.pageYOffset > sticky_1) {
                    header.current.classList.add('sticky');
                }
                else {
                    header.current.classList.remove('sticky');
                }
            };
        }
        return function () { return (window.onscroll = undefined); };
    }, [header.current]);
    return header;
}
//# sourceMappingURL=useStickyHeader.js.map